<template>
  <div :style="{ width: '100%' }">
    <spacer-special
      v-if="specialSpacer"
      :characterBlock="characterBlock"
      :channelName="channelName"
    ></spacer-special>

    <div v-else :style="{ textAlign }">
      {{ text }}
    </div>
  </div>
</template>

<script>
import SpacerSpecial from "@/components/SpacerSpecial";

export default {
  components: { SpacerSpecial },
  props: {
    channelName: String,
  },
  data() {
    return {
      // [lspacer] [cspacer] [rspacer] [*spacer] vs
      spacer: /^\[([^\]]*?)spacer([^\]]*?)\](.*)$/i,

      // çizgi tipleri
      characterBlocks: ["-..", "___", "-.-", "...", "---"],

      specialSpacer: false,
      characterBlock: "",

      text: "",
      textAlign: "left",
    };
  },
  methods: {
    analyzeSpacer(name) {
      const s = String(name || "");
      const m = s.match(this.spacer);

      if (!m) {
        // spacer değilse sadece text bas
        this.specialSpacer = false;
        this.characterBlock = "";
        this.text = s;
        this.textAlign = "left";
        return;
      }

      const before = String(m[1] || ""); // l/c/r/* gibi şeyler burada gelebilir
      const afterTag = String(m[2] || ""); // bazen ekstra şeyler
      const payload = String(m[3] || "").trim(); // ] sonrası görünen kısım

      // text kısmını her durumda ayarla
      this.text = payload;

      // 1) Çizgi blokları special
      if (this.characterBlocks.includes(payload)) {
        this.specialSpacer = true;
        this.characterBlock = payload;
        return;
      }

      // 2) TS3 repeat eden spacer: *spacer (ön/arka kısımda * varsa)
      const isStar = before.indexOf("*") !== -1 || afterTag.indexOf("*") !== -1;

      if (isStar) {
        this.specialSpacer = true;
        this.characterBlock = ""; // metinli repeat için gerek yok
        return;
      }

      // 3) Normal spacer: hizalı tek metin
      this.specialSpacer = false;
      this.characterBlock = "";
      this.setTextAlignment(before);
    },

    setTextAlignment(alignmentRaw) {
      const a = String(alignmentRaw || "").toLowerCase();
      const ch = a.length ? a[0] : "l";

      switch (ch) {
        case "l":
          this.textAlign = "left";
          break;
        case "c":
          this.textAlign = "center";
          break;
        case "r":
          this.textAlign = "right";
          break;
        default:
          this.textAlign = "left";
      }
    },
  },
  watch: {
    channelName: {
      immediate: true,
      handler(name) {
        this.analyzeSpacer(name);
      },
    },
  },
};
</script>

<style>
.spacer-wrap {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
}
</style>
